import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_ENDPOINTS } from '../../config/api';

export const fetchOrders = createAsyncThunk(
  'orders/fetchOrders',
  async ({ restaurantId, limit = 15 }) => {
    const response = await axios.get(`${API_ENDPOINTS.ORDERS}?restaurantId=${restaurantId}&limit=${limit}&sort=-orderDate`);
    return response.data;
  }
);

const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    orders: [],
    loading: false,
    error: null,
    lastFetched: null,
    unreadCount: 0,
  },
  reducers: {
    markOrderAsRead: (state, action) => {
      const order = state.orders.find(o => o._id === action.payload);
      if (order && !order.isRead) {
        order.isRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
        state.lastFetched = Date.now();
        state.unreadCount = action.payload.filter(order => !order.isRead).length;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Selectors
export const selectAllOrders = (state) => state.orders;
export const selectOrderLoading = (state) => state.orders.loading;
export const selectOrderError = (state) => state.orders.error;
export const selectUnreadCount = (state) => state.orders.unreadCount;

export const { markOrderAsRead } = orderSlice.actions;
export default orderSlice.reducer;